import React from 'react';
const CheckIcon = (props) => (React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.50016 13.5L4.00016 10L2.8335 11.1667L7.50016 15.8334L17.5002 5.83335L16.3335 4.66669L7.50016 13.5Z", fill: "#565E5E" })));
export default CheckIcon;
